module.exports = require("./as.js");